import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  & > div {
    width: 100%;
  }
`;
